import { useMutation, useQueryClient } from "@tanstack/react-query";
import { RestEndpoints } from "../../../../api/endpoints";
import getInstance from "../../../../utils/rest";
import { PomQueryKeys } from "../../../pom-query-keys";

const deleteReportingDraft = async (contractNo: string, reportingNo: number): Promise<void> => {
  await getInstance().delete(
    `${RestEndpoints.PomReportingDrafts}/${contractNo}/${reportingNo}`,
  );
};

export const useDeleteReportingDraftMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      contractNo,
      reportingNo,
    }: {
      contractNo: string;
      reportingNo: number;
    }) => deleteReportingDraft(contractNo, reportingNo),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [PomQueryKeys.GetReportingDraft, variables.contractNo, variables.reportingNo],
      });
      queryClient.invalidateQueries({
        queryKey: [PomQueryKeys.GetReportingDraftNos, variables.contractNo],
      });
    },
  });
};
